<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>查排名</el-breadcrumb-item>
        <el-breadcrumb-item>学员列表</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">学员列表</h2>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="院校名称"
          prop="name"
        >
          <el-input
            v-model="query.college_keyword"
            placeholder="输入院校名称"
            @input="fetchList()"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="学院名称"
          prop="name"
        >
          <el-input
            v-model="query.academy_keyword"
            placeholder="输入学院名称"
            @input="fetchList()"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="专业名称"
          prop="name"
        >
          <el-input
            v-model="query.major_keyword"
            placeholder="输入专业名称"
            @input="fetchList()"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="年份"
          prop="year"
        >
          <el-select
            v-model="query.year"
            placeholder="请选择"
            @input="fetchList(true)"
          >
            <el-option
              v-for="item in filter.years"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">学员列表</p>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            type="index"
            width="70"
            label="序号"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="姓名"
            align="center"
            width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="college_name"
            label="院校"
            align="center"
            width="140"
            show-overflow-tooltip
          >

          </el-table-column>
          <el-table-column
            prop="academy_name"
            label="学院"
            align="center"
            width="200"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="专业"
            align="center"
            width="260"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              ({{scope.row.major_code}}){{scope.row.major_name}}
            </template>
          </el-table-column>
          <el-table-column
            label="科目"
            align="center"
            width="350"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{formateSubject(scope.row.subjects)}}
            </template>
          </el-table-column>
          <el-table-column
            label="总分"
            align="center"
            width="80"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{scope.row.total_score}}分
            </template>
          </el-table-column>
          <el-table-column
            prop="os"
            label="科目1成绩"
            align="center"
            width="80"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{scope.row.politics_score?`${scope.row.politics_score}分`:'无'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="os"
            label="科目2成绩"
            align="center"
            width="80"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{scope.row.language_score?`${scope.row.language_score}分`:'无'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="os"
            label="科目3成绩"
            align="center"
            width="80"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{scope.row.profession1_score?`${scope.row.profession1_score}分`:'无'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="os"
            label="科目4成绩"
            align="center"
            width="80"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{scope.row.profession2_socre?`${scope.row.profession2_socre}分`:'无'}}
            </template>
          </el-table-column>
          <el-table-column
            label="成绩截图"
            align="center"
          >
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.picture_url"
                style="width: 60px; height: 60px"
                :src="scope.row.picture_url"
                :preview-src-list="[scope.row.picture_url]"
              >
              </el-image>
              <span v-else>无</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { rankuserlist } from "@/api/rank";

export default {
  components: {},
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
        year: 2024,
        major_type: this.$route.query.type
      },
      pageTotal: 10,
      results: [],
      filter: {
        years: [
           {
            label: "2027年",
            value: 2027,
          },
          {
            label: "2026年",
            value: 2026,
          },
          {
            label: "2025年",
            value: 2025,
          },
          {
            label: "2024年",
            value: 2024,
          },
          {
            label: "2023年",
            value: 2023,
          },
        ]
      }
    };
  },
  created() {
    if (this.$route.query.collegeCode) {
      this.query.college_code = this.$route.query.collegeCode
    }
    if (this.$route.query.academyCode) {
      this.query.academy_code = this.$route.query.academyCode
    }
    if (this.$route.query.majorCode) {
      this.query.major_code = this.$route.query.majorCode
    }
    if (this.$route.query.major_one_code) {
      this.query.major_one_code = this.$route.query.major_one_code
    }
    if (this.$route.query.major_two_code) {
      this.query.major_two_code = this.$route.query.major_two_code
    }
    if (this.$route.query.major_three_code) {
      this.query.major_three_code = this.$route.query.major_three_code
    }
    this.fetchList();
  },
  methods: {
    // 客户端列表请求
    fetchList() {
      rankuserlist(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchList();
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    formateSubject(subjects) {
      let arr = JSON.parse(subjects)
      return arr[0].map(v => { return `(${v.code})${v.name}` }).join('+')
    }
  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
